export interface Category {
  slug: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'hanman', name: '韩漫', icon: 'ri-global-line' },
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line' },
  { slug: 'guoman', name: '国漫', icon: 'ri-ancient-gate-line' },
  { slug: 'wanjie', name: '完结', icon: 'ri-check-double-line' },
];

export const allCategories = categories;